import { GET_CONTACT_FORM } from '@/app/_libs/utils/constants/endpoints';
import { useMutation } from '@tanstack/react-query';

async function updateForm({ values, files }) {
  var formData = new FormData();
  Object.keys(values).forEach((key) => {
    // jsonBody[key] = values[key];

    formData.append(key, values[key]);
  });
  if (files?.length > 0) {
    files.map((file, index) => {
      formData.append([`files[${index}]`], file);
    });
  }

  const res = await fetch(`${GET_CONTACT_FORM}`, {
    method: 'POST',
    body: formData,
    headers: new Headers({
      Accept: 'application/json',
    }),
  });
  const resInfo = await res.json();
  return resInfo;
}

const useUpdateForm = () => {
  return useMutation({
    mutationFn: ({ values, files }) => updateForm({ values, files }),
  });
};
export { useUpdateForm };
